import { SKELETON_WIDTHS, Skeleton, skeletonWidth } from '@forecastify/ui';
import { useT } from '../../i18n';

/**
 * The people grid before its first answer — Logolás and Erőforrás alike: the 240px person column
 * and a three-line block per person, as placeholders. Their own empty state says *nobody here*,
 * which is the wrong thing to tell somebody whose team is still arriving. `lines` is 1 for the
 * leave timeline, whose rows are one 34px bar each.
 */
export function PeopleGridSkeleton({ lines = 3 }: { readonly lines?: 1 | 3 }) {
  const t = useT();

  return (
    <div className="min-h-0 flex-1 overflow-hidden">
      <div role="status" aria-live="polite" className="sr-only">
        {t('state.loading')}
      </div>
      <div aria-hidden>
        <div className="bg-muted h-[41px] border-b" />
        {(lines === 1 ? SKELETON_WIDTHS : SKELETON_WIDTHS.slice(0, 6)).map((_widths, index) =>
          lines === 1 ? (
            <div key={index} className="flex h-[34px] items-center border-b">
              <div className="w-[240px] shrink-0 border-r px-3">
                <Skeleton width={skeletonWidth(index, 0)} />
              </div>
              <div className="flex-1 px-3">
                <Skeleton width={skeletonWidth(index, 2) / 3} className="h-4" />
              </div>
            </div>
          ) : (
            <div key={index} className="flex border-b">
              <div className="flex w-[240px] shrink-0 items-start gap-2 border-r px-3 py-3">
                <Skeleton className="size-6 shrink-0 rounded-full" />
                <div className="flex min-w-0 flex-1 flex-col gap-1.5 pt-1">
                  <Skeleton width={skeletonWidth(index, 0)} />
                  <Skeleton width={skeletonWidth(index, 1) / 2} className="h-2.5" />
                </div>
              </div>
              <div className="flex flex-1 flex-col justify-center gap-2.5 px-3 py-3">
                {[0, 1, 2].map((line) => (
                  <Skeleton key={line} width={skeletonWidth(index, line + 2)} className="h-2.5" />
                ))}
              </div>
            </div>
          ),
        )}
      </div>
    </div>
  );
}
